import { ToastStoreContext } from '#pplx/frontend/aether/toasts/internal/ToastStoreContext.js';
import { assertDefined } from '#pplx/frontend/common/type_utils/assertDefined.js';
import { useContext } from 'react';
import { useStore } from 'zustand';
import { useShallow } from 'zustand/react/shallow';
const MISSING_PROVIDER_ERROR = 'ToastStoreContext must be used within a ToastStoreProvider';
export const useToastStore = (selector) => {
    const ctx = useContext(ToastStoreContext);
    assertDefined(ctx, MISSING_PROVIDER_ERROR);
    return useStore(ctx, useShallow(selector));
};
//# sourceMappingURL=useToastStore.js.map